import { Controller } from 'react-hook-form'
import { Link } from 'react-router-dom'
import { FormatISODateTime } from '../../../helpers/formatting'
import SuccessIcon from "../../../components/elements/SuccessIcon";
import DeclineIcon from "../../../components/elements/DeclineIcon";

export default function BankAccountForm(props) {
  const { control, responseData, actionDisabled } = props

  return (
    <>
      <h3>
        On {FormatISODateTime(responseData?.created_at)}, Agent <Link to={`user/${responseData?.agent_user_id}`} className="is-link" target="_blank"><b>{responseData?.agent_user_label}</b></Link> requested manager approval for customer <Link to={`customer/${responseData?.customer_id}`} className="is-link" target="_blank"><b>{responseData?.customer_label}</b></Link>&apos;s Bank Account.
      </h3>
      <h3>{responseData?.description}</h3>

      <div className="divider m-0 my-2"></div>

     <br />
      <div className="columns is-multiline">
        <div className="column">
          <p className="mb-2"><strong>Account Holder Name: </strong>{responseData?.bank_account?.bank_account_holder_name}</p>
          <p className="mb-2"><strong>Account Number: </strong>{responseData?.bank_account?.bank_account_number}</p>
          <p className="mb-2"><strong>Account Number Clean: </strong>{responseData?.bank_account?.bank_account_number_clean}</p>
          <p className="mb-2"><strong>Routing Number: </strong>{responseData?.bank_account?.bank_routing_number}</p>
          <p className="mb-2"><strong>Bank Name: </strong>{responseData?.bank_account?.bank_name}</p>
          <p className="mb-2"><strong className="mr-2">Is Bank Savings: </strong>{responseData?.bank_account?.is_bank_savings ? <SuccessIcon /> : <DeclineIcon />}</p>
          <p className="mb-2"><strong className="mr-2">Is Online Banking: </strong>{responseData?.bank_account?.is_online_banking ? <SuccessIcon /> : <DeclineIcon />}</p>
          <p className="mb-2"><strong className="mr-2">Is Direct Deposit: </strong>{responseData?.bank_account?.is_direct_deposit ? <SuccessIcon /> : <DeclineIcon />}</p>
        </div>
      </div>
    </>
  )
}
